
import {initWebComponent} from "@/helpers/web-component-helper";

export class HeaderDividerComponent extends HTMLElement {
    constructor(){
        super();
        let height = this.getAttribute('data-height')
        if(height === null) {
            height = 30
        }
        let className = this.getAttribute('data-class')
        if(className === null) {
            className = ''
        }

        const template = document.createElement('template');

        template.innerHTML = `<div class="nav-item border-left ml-2 mr-2 ` + className + `" style="border-left-width: 1px;height:` + height + `px"></div>`;

        initWebComponent(this, template)
    }
}

